<template>
  <div>
    <div class="headline__stor" v-if="user && user.role.id === 1 && user.is_outside === 1">
      Баланс: {{ user.balance }} руб. Подписка до: {{ reDate(user.property.outside_trainer.active_to.date) }}
    </div>
    <div class="headline__stor" v-if="user && user.role.id === 2 && user.is_outside === 1 && typeof user.property.expired !== 'undefined'">
      Подписка до: {{ user.property.expired }}
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: "outsider_headline",
  data() {
    return {}
  },
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  props: {
    items: ''
  },
  methods: {
    reDate(date) {
      if (date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY HH:mm');
      }
    }
  }
}
</script>